export default {
      id: "logo-irop-usage",
      viewBox: "0 0 357 100",
      url: __webpack_public_path__ + "../images/sprites.svg#logo-irop",
      toString: function () {
        return this.url;
      }
    }